import moment from "moment";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";
import Loader from "../../loder/Loader";
import { useAuthDispatch, useAuthState } from "../../../context/context";
import auth from "../../../constant";
import API from "../../../services/API";

const DeleteExpense = ({ expenseInfo, close }) => {
  const dispatch = useAuthDispatch();
  const state = useAuthState();
  const { _id, amount, date, dept, cat, name, remarks } = expenseInfo;
  const id = _id;
  const [successMessage, setSuccessMessage] = useState("");
  const handleDelete = async (id) => {
    dispatch({ type: auth.filter.FILTER_REQUEST });
    try {
      const { data } = await API({
        method: "delete",
        url: "/api/auth-delete-expense",
        data: { id },
      });
      if (data?.success) {
        setSuccessMessage(data?.message);
        dispatch({ type: auth.filter.FILTER_SUCCESS });
        setTimeout(close, 1000);
      }
    } catch (error) {
      dispatch({ type: auth.ERROR });
      console.error(error);
    }
  };
  return (
    <>
      <div className="delete-container">
        <div className="delete-sub-container">
          <h5 className="delete-info">Would you like to delete?</h5>
          <ul>
            <li className="delete-flex">
              <p>Amount</p>
              <span>{`${amount}`}</span>
            </li>

            <li className="delete-flex">
              <p>Date</p>
              <span>{moment(date).format("DD/MM/YYYY")}</span>
            </li>

            <li className="delete-flex">
              <p>Department</p>
              <span>{`${dept.toUpperCase()}`}</span>
            </li>

            <li className="delete-flex">
              <p>Category</p>
              <span>{`${cat.toUpperCase()}`}</span>
            </li>
            <li className="delete-flex">
              <p>Name</p>
              <span>{name.toUpperCase()}</span>
            </li>
            {remarks && (
              <li className="delete-flex">
                <p>Remarks</p>
                <span>{remarks.toUpperCase()}</span>
              </li>
            )}
          </ul>
        </div>
      </div>
      <Stack>
        <p style={{ color: "green", textAlign: "center" }}>{successMessage}</p>
        <Button type="click" onClick={() => handleDelete(id)}>
          {state?.floading ? <Loader /> : "Deleted"}
        </Button>
      </Stack>
    </>
  );
};

export default DeleteExpense;
